import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Alert,
  Box,
  Typography,
  CircularProgress,
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LoginIcon from '@mui/icons-material/Login';
import { useAuth } from '../context/AuthContext';

function LoginModal({ open }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!email || !password) {
      setError('Por favor, completa todos los campos');
      setLoading(false);
      return;
    }

    const result = await login(email, password);
    if (!result.success) {
      setError(result.error);
      setPassword('');
    }
    setLoading(false);
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: '16px',
          padding: '1rem',
          minWidth: { xs: '90%', sm: '450px' },
        },
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
          <LoginIcon sx={{ fontSize: 48, color: '#600002' }} />
          <Typography variant="h5" sx={{ fontWeight: 600, color: '#600002' }}>
            Iniciar Sesión
          </Typography>
          <Typography variant="body2" sx={{ color: '#666' }}>
            Ingresa tus credenciales para acceder al dashboard
          </Typography>
        </Box>
      </DialogTitle>
      
      <form onSubmit={handleSubmit}>
        <DialogContent sx={{ pt: 2 }}>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          
          <TextField
            autoFocus
            margin="dense"
            label="Email"
            type="email"
            fullWidth
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
            sx={{
              mb: 2,
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': {
                  borderColor: '#E31C24',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#600002',
                },
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: '#600002',
              },
            }}
          />
          
          <TextField
            margin="dense"
            label="Contraseña"
            type={showPassword ? 'text' : 'password'}
            fullWidth
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    edge="end"
                    sx={{ padding: '12px' }}
                  >
                    {showPassword ? (
                      <VisibilityOff sx={{ fontSize: '50px', height: '15%' }} />
                    ) : (
                      <Visibility sx={{ fontSize: '50px' ,  height: '15%' }} />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': {
                  borderColor: '#E31C24',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#600002',
                },
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: '#600002',
              },
            }}
          />

        </DialogContent>
        
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : null}
            sx={{
              backgroundColor: '#600002',
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 600,
              py: 1.5,
              '&:hover': {
                backgroundColor: '#E31C24',
              },
              '&:disabled': {
                backgroundColor: '#999',
              },
            }}
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default LoginModal;

